<template>
  <header class="dashboard-header">
    <div class="header-content">
      <h1 class="text-2xl font-bold text-gray-900">Dashboard Overview</h1>
      <div class="header-actions">
        <div class="date-range-picker">
          <div class="date-inputs">
            <div class="date-input-group">
              <label for="start-date" class="date-label">From</label>
              <input 
                type="date" 
                id="start-date" 
                class="date-input" 
                :value="startDate" 
                @change="e => $emit('update-date-range', 'start', e.target.value)"
              />
            </div>
            <div class="date-input-group">
              <label for="end-date" class="date-label">To</label>
              <input 
                type="date" 
                id="end-date" 
                class="date-input" 
                :value="endDate" 
                @change="e => $emit('update-date-range', 'end', e.target.value)"
              />
            </div>
          </div>
          <div class="preset-ranges">
            <button 
              v-for="range in dateRangePresets" 
              :key="range.key"
              @click="$emit('set-date-range', range.key)"
              :class="['preset-btn', { active: currentDatePreset === range.key }]"
            >
              {{ range.label }}
            </button>
          </div>
        </div>
        <button @click="$emit('apply-date-range')" class="apply-range-btn">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
          <span>Apply</span>
        </button>
        <button @click="$emit('refresh')" class="refresh-btn" :disabled="isLoading">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
          </svg>
          <span>Refresh</span>
        </button>
        <div class="date-range">
          <span class="text-sm text-gray-600">Last updated: {{ lastUpdated }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'DashboardHeader',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    dateRangePresets: {
      type: Array,
      required: true
    },
    currentDatePreset: {
      type: String,
      required: true
    },
    lastUpdated: {
      type: String,
      required: true
    }
  },
  emits: ['refresh', 'update-date-range', 'set-date-range', 'apply-date-range']
}
</script>

<style scoped>
.dashboard-header {
  @apply mb-6 sm:mb-8;
}

.header-content {
  @apply flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4;
}

.header-actions {
  @apply flex items-center gap-4;
}

.date-range-picker {
  @apply bg-white rounded-lg shadow-sm p-2 flex flex-col sm:flex-row gap-2;
}

.date-inputs {
  @apply flex items-center gap-2;
}

.date-input-group {
  @apply flex flex-col;
}

.date-label {
  @apply text-xs text-gray-500 mb-1;
}

.date-input {
  @apply px-2 py-1 border border-gray-200 rounded-md text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500;
  min-width: 120px;
}

.preset-ranges {
  @apply flex items-center gap-1 flex-wrap;
}

.preset-btn {
  @apply px-2 py-1 text-xs font-medium rounded-md transition-colors duration-200;
}

.preset-btn.active {
  @apply bg-indigo-100 text-indigo-700;
}

.preset-btn:not(.active) {
  @apply text-gray-500 hover:bg-gray-100;
}

.apply-range-btn {
  @apply flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg shadow-sm
         text-sm font-medium transition-colors duration-200;
}

.refresh-btn {
  @apply flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-sm hover:bg-gray-50 
         text-gray-700 text-sm font-medium transition-colors duration-200;
}

.refresh-btn:disabled {
  @apply opacity-50 cursor-not-allowed;
}

.date-range {
  @apply text-sm text-gray-500;
}

@media (max-width: 640px) {
  .header-actions {
    @apply flex-wrap;
  }
  
  .date-range {
    @apply hidden;
  }
}
</style> 